'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _dec2, _dec3, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _chemist = require('chemist');

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _reactI18next = require('react-i18next');

var _paintersStyle = require('./paintersStyle.scss');

var _paintersStyle2 = _interopRequireDefault(_paintersStyle);

var _Icon = require('../../components/Icon');

var _Icon2 = _interopRequireDefault(_Icon);

var _Navigation = require('../../components/Navigation');

var _Navigation2 = _interopRequireDefault(_Navigation);

var _localisedPaths = require('../../helpers/localisedPaths');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PaintersFooter = (_dec = (0, _reactI18next.translate)(), _dec2 = (0, _chemist.configurable)(), _dec3 = (0, _reactCssModules2.default)(_paintersStyle2.default, { allowMultiple: true }), _dec(_class = _dec2(_class = _dec3(_class = (_temp = _class2 = function (_React$Component) {
  (0, _inherits3.default)(PaintersFooter, _React$Component);

  function PaintersFooter() {
    (0, _classCallCheck3.default)(this, PaintersFooter);
    return (0, _possibleConstructorReturn3.default)(this, (PaintersFooter.__proto__ || (0, _getPrototypeOf2.default)(PaintersFooter)).apply(this, arguments));
  }

  (0, _createClass3.default)(PaintersFooter, [{
    key: 'render',
    value: function render() {
      var lng = this.props.params.lng;
      var t = this.props.t;
      var _props$config$store = this.props.config.store,
          _props$config$store$d = _props$config$store.disabledFooterLinks,
          disabledFooterLinks = _props$config$store$d === undefined ? [] : _props$config$store$d,
          _props$config$store$r = _props$config$store.renderFooterPromotions,
          renderFooterPromotions = _props$config$store$r === undefined ? false : _props$config$store$r,
          _props$config$store$a = _props$config$store.acceptedCardTypes,
          acceptedCardTypes = _props$config$store$a === undefined ? [] : _props$config$store$a,
          _props$config$store$d2 = _props$config$store.displayAdditionalCardTypes,
          displayAdditionalCardTypes = _props$config$store$d2 === undefined ? [] : _props$config$store$d2;

      var links = [{
        id: 'terms_and_conditions',
        href: (0, _localisedPaths.localisedPath)(this.props.config.store, 'termsConditionsPath', lng),
        text: t('painters.footer.terms_and_conditions'),
        class: 'a-link--navigation'
      }, {
        id: 'terms_of_use',
        href: (0, _localisedPaths.localisedPath)(this.props.config.store, 'termsOfUsePath', lng),
        text: t('painters.footer.terms_of_use'),
        class: 'a-link--navigation'
      }, {
        id: 'cookie_policy',
        href: (0, _localisedPaths.localisedPath)(this.props.config.store, 'cookiePolicyPath', lng),
        text: t('painters.footer.cookie_policy'),
        class: 'a-link--navigation'
      }, {
        id: 'privacy_policy',
        href: (0, _localisedPaths.localisedPath)(this.props.config.store, 'privacyPolicyPath', lng),
        text: t('painters.footer.privacy_policy'),
        class: 'a-link--navigation'
      }, {
        id: 'disclaimer',
        href: (0, _localisedPaths.localisedPath)(this.props.config.store, 'disclaimerPath', lng),
        text: t('painters.footer.disclaimer'),
        class: 'a-link--navigation'
      }].filter(function (link) {
        return !disabledFooterLinks.includes(link.id);
      });

      return _react2.default.createElement(
        'footer',
        { styleName: 'footer' },
        _react2.default.createElement(
          'div',
          { styleName: 'container' },
          renderFooterPromotions && _react2.default.createElement(
            'div',
            { styleName: 'contact' },
            _react2.default.createElement(
              'div',
              { styleName: 'contactItem contactItemFirst' },
              _react2.default.createElement(
                'div',
                { styleName: 'contactItemPaymentTitle' },
                t('painters.footer.accepted_payment_methods')
              ),
              [].concat((0, _toConsumableArray3.default)(acceptedCardTypes), (0, _toConsumableArray3.default)(displayAdditionalCardTypes)).map(function (cardType) {
                return _react2.default.createElement(_Icon2.default, { key: cardType, type: cardType });
              })
            ),
            _react2.default.createElement(
              'div',
              { styleName: 'contactItem' },
              _react2.default.createElement(
                'div',
                { styleName: 'contactItemIcon' },
                _react2.default.createElement(_Icon2.default, { type: 'painters-phone' })
              ),
              _react2.default.createElement(
                'strong',
                null,
                t('painters.footer.contact_title')
              ),
              _react2.default.createElement('br', null),
              t('painters.footer.contact_content')
            ),
            _react2.default.createElement(
              'div',
              { styleName: 'contactItem contactItemLast' },
              _react2.default.createElement(
                'div',
                { styleName: 'contactItemIcon' },
                _react2.default.createElement(_Icon2.default, { type: 'painters-truck' })
              ),
              _react2.default.createElement(
                'strong',
                null,
                t('painters.footer.delivery_time_title')
              ),
              _react2.default.createElement('br', null),
              t('painters.footer.delivery_time_content')
            )
          ),
          _react2.default.createElement(
            'div',
            { styleName: 'flourishFooter' },
            _react2.default.createElement(_Navigation2.default, { links: links })
          ),
          _react2.default.createElement(
            'div',
            { styleName: 'akzoFooter' },
            _react2.default.createElement(
              'div',
              { className: 'row' },
              _react2.default.createElement(
                'div',
                { styleName: 'copyrightText' },
                t('painters.footer.copyright_notice')
              )
            )
          )
        )
      );
    }
  }]);
  return PaintersFooter;
}(_react2.default.Component), _class2.propTypes = {
  params: _react.PropTypes.object
}, _class2.defaultProps = {
  params: {}
}, _temp)) || _class) || _class) || _class);
exports.default = PaintersFooter;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./shared/components/Footer/painters.js
// module id = 2283
// module chunks = 0